import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'bluechat-badge',
  templateUrl: './blue-chat-badge.component.html',
  styleUrls: ['./blue-chat-badge.component.scss']
})
export class BlueChatBadgeComponent implements OnInit {

  @Input()
  bluechatActivated: boolean;

  constructor() { }

  ngOnInit() {
  }

}
